import { useReactiveVar } from '@apollo/client';
import { Stack, TextView } from '@fluentui/react';
import clsx from 'clsx';
import React from 'react';
import { expandedNav } from 'utility/cache/ui';
import { ActiveApprovalTypes_Query } from '../__generated__/ActiveApprovalTypes';
import { useStyles } from './index.styles';

type ApprovalTypeFilterProps = {
  onChange: (value: number | undefined) => void;
  value: number | undefined;
  projectPhase: string | undefined;
  data: ActiveApprovalTypes_Query | undefined;
};

export const ApprovalTypeFilter: React.FC<ApprovalTypeFilterProps> = (
  props
) => {
  const styles = useStyles();
  const isExpandedNav = useReactiveVar(expandedNav);

  return (
    <Stack
      style={{
        maxWidth: `calc(100vw - ${isExpandedNav ? 500 : 320}px)`, // Adjust 20px based on scrollbar size
      }}
    >
      <Stack
        className={styles.scrollContainer}
        horizontal
        wrap
        tokens={{ childrenGap: 10 }}
      >
        {props.data?.activeApprovalTypes?.nodes.map((item, index) => {
          const isSelected = props.value === item.id;
          return (
            <Stack
              onClick={() => {
                if (!isSelected) {
                  props.onChange(isSelected ? undefined : item.id);
                }
              }}
              className={clsx(
                styles.root,
                isSelected ? styles.selected : styles.unselected
              )}
              key={index}
            >
              <TextView>{`${item.approvalType} (${item._activeCount})`}</TextView>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
